export default __webpack_public_path__ + "static/media/kmx_pools.dbf053a2.svg";